import React from 'react';

const BakBox7 = (props) => {

    return (
        <div className="back7">
            <a className="lista-botones">
                <p className="posicion">{props.Posicion}</p>
                <h3 className="art-name">&nbsp;{props.Nombre}</h3>
                {props.Puntuacion !== undefined && <div>
                    <ul class="stars5 mt-1">
                        {props.generarEstrellas(props.Puntuacion)}
                    </ul>
                </div>}
                <p className="codigo">cód: {props.Id}</p>
            </a>
        </div>
    );

}
export default BakBox7;